/* eslint-disable no-undef */
import { useEffect, useRef, useState } from "react";
import { quotationAPI } from "../../../api/quotationAPI";
import { toast } from "react-toastify";

export default function ItemModal({
    pCode, handleItemAdd
}) {
    const [itemCode, setItemCode] = useState('');
    const [itemName, setItemName] = useState('');
    const [sellPrice, setSellPrice] = useState('');
    const [warrantyYear, setWarrantyYear] = useState(0);
    const [warrantyMonth, setWarrantyMonth] = useState(0);
    const [qty, setQty] = useState(0);
    const [discAmt, setDiscAmt] = useState(0);
    const [vATYesNo, setVAT] = useState('No');
    const [unitTotal, setUnitTotal] = useState('');
    const [stock, setStock] = useState(0);
    const [resetKey, setResetKey] = useState(0);
    const [allItems, setAllItems] = useState([]);
    const [searchKey, setSearchKey] = useState('');

    useEffect(() => {
        const modalElement = document.getElementById("itemModal");
        const searchInput = document.getElementById("searchInput");

        const handleModalClose = () => {
            setSearchKey("");
            searchInput.value = "";
            handleClear();
        };

        if (modalElement) {
            modalElement.addEventListener("hidden.bs.modal", handleModalClose);
        }

        return () => {
            if (modalElement) {
                modalElement.removeEventListener("hidden.bs.modal", handleModalClose);
            }
        };
    }, []);

    const onAddItems = () => {
        if (!itemCode || !itemName) {
            toast.warning("Please select an item before adding.");
            return;
        }

        if (!qty || qty <= 0) {
            toast.warning("Please enter a quantity greater than zero.");
            return;
        }

        const newItem = {
            itemCode,
            itemName,
            warrantyYear,
            warrantyMonth,
            qty,
            sellPrice,
            discAmt,
            vATYesNo,
            unitTotal,
            stock
        };

        handleItemAdd(newItem);
        handleClear();

        // Close the modal
        const modalElement = document.getElementById("itemModal");
        const modalInstance = bootstrap.Modal.getInstance(modalElement);
        if (modalInstance) {
            modalInstance.hide();
        }

    };

    const handleClear = () => {
        setResetKey(resetKey + 1);
        setItemCode('');
        setItemName('');
        setSellPrice('');
        setWarrantyYear(0);
        setWarrantyMonth(0);
        setQty(0);
        setDiscAmt('');
        setVAT('No');
        setUnitTotal('');
        setStock('');
    }

    const getAllItems = () => {
        quotationAPI.getItems(searchKey, pCode).then((data) => {
            setAllItems(data);
        });
    };

    const handleRowClick = (code, name, price) => {
        setItemCode(code);
        setItemName(name);
        setSellPrice(price);
    }

    useEffect(() => {
        getAllItems()
    }, [searchKey, pCode]);

    useEffect(() => {
        const price = parseFloat(sellPrice) || 0;
        const discount = parseFloat(discAmt) || 0;
        const quantity = parseInt(qty) || 1;

        const calculatedUnitTotal = (price - discount) * quantity;

        setUnitTotal(isNaN(calculatedUnitTotal) ? sellPrice : calculatedUnitTotal.toFixed(2));
    }, [sellPrice, discAmt, qty]);

    return (
        <>
            <div className="modal fade" id="itemModal" tabIndex="-1" aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Add Item</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
                        </div>
                        <div className="modal-body">
                            <form>
                                <div class="form-group row">
                                    <input
                                        id="searchInput"
                                        type="text"
                                        className="col-2 col-xs-12 col-sm-12 col-md-12 col-lg-3 col-xl-3 form-control"
                                        placeholder="Search by code or name"
                                        onChange={(e) => setSearchKey(e.target.value)}
                                    />
                                    <div class="col-12 col-xs-12 col-sm-12 col-md-3 col-lg-10 col-xl-10 input_field">
                                    </div>
                                    <div class="col-2 col-xs-12 col-sm-12 col-md-3 col-lg-1 col-xl-1 form-check">
                                    </div>
                                </div>

                                <div class=" table-container form-group row">
                                    <table className="table mt-1">
                                        <thead className="thead--color">
                                            <tr>
                                                <th scope="col">Item Code</th>
                                                <th scope="col">Description</th>
                                                <th scope="col">Sell Price</th>
                                                <th className="text-center">Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {allItems.map((data, index) => (
                                                <tr key={index}>
                                                    <td>{data.itemCode}</td>
                                                    <td>{data.itemName}</td>
                                                    <td>{Number(data.sellPrice).toFixed(2)}</td>
                                                    <td className="text-center"><button type="button" className="btn btn-sm btn-dark"
                                                        onClick={() => handleRowClick(data.itemCode, data.itemName, data.sellPrice)}>
                                                        Select</button></td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                    <div class="col-12 col-xs-12 col-sm-12 col-md-3 col-lg-10 col-xl-10 input_field">
                                    </div>
                                    <div class="col-2 col-xs-12 col-sm-12 col-md-3 col-lg-1 col-xl-1 form-check">
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <label for="staticEmail"
                                        class="col-12 col-xs-12 col-sm-3 col-md-12 col-lg-3 col-xl-3 col-form-label">
                                        Item
                                    </label>
                                    <div class="col-3 col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 input_field">
                                        <input
                                            type="text"
                                            class="form-control"
                                            id="inputPassword"
                                            value={itemCode}
                                            onChange={(e) => setItemCode(e.target.value)}
                                            disabled
                                        />
                                    </div>

                                    <div
                                        class="col-9 col-xs-12 col-sm-12 col-md-3 col-lg-6 col-xl-6 form-check">
                                        <input
                                            type="text"
                                            class="form-control"
                                            id="inputPassword"
                                            value={itemName}
                                            onChange={(e) => setItemName(e.target.value)}
                                            disabled
                                        />
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="staticEmail"
                                        class="col-2 col-xs-12 col-sm-12 col-md-12 col-lg-3 col-xl-3 col-form-label">W.Y</label>
                                    <div class="col-4 col-xs-12 col-sm-12 col-md-6 col-lg-3 col-xl-3 input_field">
                                        <input type="text" class="form-control" id="inputPassword"
                                            value={warrantyYear}
                                            onChange={(e) => setWarrantyYear(e.target.value)}
                                        />
                                    </div>
                                    <label for="staticEmail" class="col-2 col-xs-12 col-sm-12 col-md-12 col-lg-3 col-xl-3 col-form-label">W.M</label>
                                    <div class="col-4 col-xs-12 col-sm-12 col-md-6 col-lg-3 col-xl-3 input_field">
                                        <input type="text" class="form-control" id="inputPassword"
                                            value={warrantyMonth}
                                            onChange={(e) => setWarrantyMonth(e.target.value)}
                                        />
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="staticEmail" class="col-2 col-xs-12 col-sm-12 col-md-12 col-lg-3 col-xl-3 col-form-label">Qty</label>
                                    <div class="col-4 col-xs-12 col-sm-12 col-md-6 col-lg-3 col-xl-3 input_field">
                                        <input type="text" class="form-control" id="inputPassword"
                                            value={qty}
                                            onChange={(e) => setQty(e.target.value)}
                                        />
                                    </div>
                                    <label for="staticEmail" class="col-2 col-xs-12 col-sm-12 col-md-12 col-lg-3 col-xl-3 col-form-label">Sell Price</label>
                                    <div class="col-4 col-xs-12 col-sm-12 col-md-6 col-lg-3 col-xl-3 input_field">
                                        <input type="text" class="form-control" id="inputPassword"
                                            value={sellPrice}
                                            onChange={(e) => setSellPrice(e.target.value)}
                                        />
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="staticEmail"
                                        class="col-2 col-xs-12 col-sm-12 col-md-12 col-lg-3 col-xl-3 col-form-label">Disc Amt</label>
                                    <div class="col-4 col-xs-12 col-sm-12 col-md-6 col-lg-3 col-xl-3 input_field">
                                        <input type="text" class="form-control" id="inputPassword"
                                            value={discAmt}
                                            onChange={(e) => setDiscAmt(e.target.value)}
                                        />
                                    </div>
                                    <label for="staticEmail"
                                        class="col-2 col-xs-12 col-sm-12 col-md-12 col-lg-3 col-xl-3 col-form-label">VAT</label>
                                    <div class="col-4 col-xs-12 col-sm-12 col-md-6 col-lg-3 col-xl-3 input_field">
                                        <input type="text" class="form-control" id="inputPassword"
                                            value={vATYesNo}
                                            onChange={(e) => setVAT(e.target.value)}
                                        />
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="staticEmail"
                                        class="col-12 col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4 col-form-label">Unit Total Without VAT</label>
                                    <div class="col-9 col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                        <input type="text" class="form-control" id="inputPassword"
                                            value={unitTotal}
                                            disabled
                                        />
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="staticEmail"
                                        class="col-12 col-xs-2 col-sm-12 col-md-6 col-lg-4 col-xl-4 col-form-label">
                                        Stock
                                    </label>
                                    <div class="col-9 col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                        <input type="text" class="form-control" id="inputPassword"
                                            value={stock}
                                            onChange={(e) => setStock(e.target.value)}
                                            disabled
                                        />
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 col-xxl-6'>
                                        <button type="button" className="btn btn-dark form-control mt-1"
                                            onClick={onAddItems}
                                            disabled={!itemCode || !itemName}
                                        >
                                            Add
                                        </button>
                                    </div>
                                    <div className='col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 col-xxl-6'>
                                        <button type="button" className="btn btn-dark form-control mt-1"
                                            onClick={() => handleClear()}
                                        >Clear</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )

}